/**
 * Sample page JS provided here for extension. Might not be useful if all JS is based on components.
 */
class ExternalLinks extends DrupalBehavior {

    onContent(context) {
        this.externalLinks(context);
    }

    externalLinks(context) {
        const elements = once('external-links', ':scope', context);
        if (elements.length === 0) return;

        const links = once('external-links-a', 'a[href]', context);
        links.forEach((link) => {
            if (!this.isExternal(link.getAttribute('href'))) return;

            if (link.querySelector('img')) return;

            link.classList.add('is-external');
            const icon = document.createElement('span');
            icon.className = 'external-link-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML = this.svgIcon();

            // If the link wraps a block-level element, append the icon inside
            // the last one so it flows with the text rather than sitting outside
            // the block on its own line.
            const blockSelector = 'h1,h2,h3,h4,h5,h6,p,div,li,dt,dd,figcaption';
            const blockChildren = link.querySelectorAll(blockSelector);
            const target = blockChildren.length
                ? blockChildren[blockChildren.length - 1]
                : link;
            target.appendChild(icon);
        });
    }

    svgIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M4.66667 2V3.33333H1.33333V10.6667H8.66667V7.33333H10V11.3333C10 11.7015 9.70153 12 9.33333 12H0.666667C0.29848 12 0 11.7015 0 11.3333V2.66667C0 2.29848 0.29848 2 0.666667 2H4.66667ZM12 0V5.33333H10.6667L10.6666 2.27533L5.4714 7.4714L4.52859 6.5286L9.72327 1.33333H6.66667V0H12Z" fill="currentColor"/>
        </svg>`;
    }

    /**
     * Returns true if the URL should be treated as external (e.g. open in new tab, add icon).
     * Internal: pennstatehealth.org, www.pennstatehealth.org, *.prod.acquia-sites.com, relative paths.
     */
    isExternal(url) {
        if (!url || typeof url !== 'string') return false;
        const trimmed = url.trim();
        if (!trimmed) return false;

        // Fragment-only, mailto, tel, and javascript are not external
        if (/^#|^mailto:|^tel:|^javascript:/i.test(trimmed)) return false;

        try {
            const parsed = new URL(url, window.location.origin);
            if (!['http:', 'https:'].includes(parsed.protocol)) return false;

            const host = parsed.hostname.toLowerCase();
            if (!host) return false;

            // Relative URLs (e.g. /careers, ?page=1, ../foo) resolve to the
            // current origin — treat any same-host URL as internal.
            if (host === window.location.hostname) return false;

            if (host === 'pennstatehealth.org' || host === 'www.pennstatehealth.org') return false;
            if (host.endsWith('.prod.acquia-sites.com')) return false;

            return true;
        } catch (e) {
            return false;
        }
    }

}

DrupalBehavior.register('psh_theme.libraries', 'external-links', ExternalLinks);
